class BrowserDataApi {

    checkLocalStorage(){
        return ('localStorage' in window);
    }

    getLocalItem(key){
        return localStorage.getItem(key);
    }

    setLocalItem(key, data){
        localStorage.setItem(key, data);
    }

    getCookie(){
        return document.cookie;
    }

    setCookie(key, data){
        document.cookie = [key, data].join('=');
    }
}

export default BrowserDataApi;


// WEBPACK FOOTER //
// ./src/utils/browserDataApi.js